Jelly.Actions.Show_Staggered_Input = function (Parameters){
	
	// Get next hidden input
	var Current_Stagger_Index = 0;
	var $Current_Stagger_Wrapper;
	do {
		Current_Stagger_Index++;
		$Current_Stagger_Wrapper = $("#" + Parameters.Namespace + "_" + Parameters.Input_Alias + "_" + Current_Stagger_Index + "_Wrapper");
		// console.log($Current_Stagger_Wrapper.length);
		// console.log($Current_Stagger_Wrapper.is(":visible"));
	}
	while ($Current_Stagger_Wrapper.length && $Current_Stagger_Wrapper.is(":visible"));

	// console.log($Current_Stagger_Wrapper);

	// If we have something, show it.
	$Current_Stagger_Wrapper.show()

	// Check if there's an upcoming staggered input, hide if not.
	if (!
		$("#" + Parameters.Namespace + "_" + Parameters.Input_Alias + "_" + (Current_Stagger_Index + 1) + "_Wrapper").length
	)
		$("#" + Parameters.Namespace + "_" + Parameters.Input_Alias + "_Show_Staggered_Input_Button").hide();

	return (Current_Stagger_Index);
};
